import * as t from "io-ts";

export const CapabilityCodec = t.exact(
  t.intersection([
    t.type({
      code: t.string,
      displayName: t.string,
      metadata: t.record(t.string, t.string),
      scope: t.string,
      enabled: t.boolean,
    }),
    t.partial({
      letter: t.string,
      iconKey: t.string,
      colorBg: t.string,
      colorFg: t.string,
      url: t.string,
    }),
  ])
);

export type Capability = t.TypeOf<typeof CapabilityCodec>;

export const CapabilityGroupCodec = t.exact(
  t.type({
    id: t.string,
    displayName: t.string,
    order: t.number,
    items: t.array(CapabilityCodec),
  })
);

export type CapabilityGroup = t.TypeOf<typeof CapabilityGroupCodec>;

export const findCapability = (caps: Capability[], code: string) : Capability | undefined => {
  const target = code.toUpperCase();
  return caps.find(c => c.code.toUpperCase() === target);
}

export const flattenGroups = (groups: CapabilityGroup[]) : Capability[] => {
  return groups.flatMap(g => g.items);
}
